import { jsx as _jsx } from "react/jsx-runtime";
import { Loader } from '../components/loader';
import React, { useEffect } from 'react';
export var Main = function Main() {
    useEffect(function() {
        window.location.href = 'https://zephyr-cloud.io/';
    }, []);
    return /*#__PURE__*/ _jsx(Loader, {});
};
